import BeardTab from "../components/BeardTab";
import BeardRequestsList from "../components/BeardRequestsList";
import BeardFlightsList from "../components/BeardFlightsList";
import BeardSubscriptionsList from "../components/BeardSubscriptionsList";
import withQueryClient from "~/helpers/withQueryClient";
import Loading from "~/components/Loading";
import useBeardCounts from "../hooks/useBeardCounts";

const TABS = {
    SUBSCRIPTIONS: 'subscriptions',
    REQUESTS: 'requests',
    FLIGHTS: 'flights',
}

function OrdersBeardContainer() {
    const [isOpened, setIsOpened] = React.useState(false)
    const [tab, setTab] = React.useState(TABS.REQUESTS)
    const queryClient = ReactQuery.useQueryClient()

    const { data: counts } = useBeardCounts()

    React.useEffect(() => {
        if (counts.requests_unviewed.length > 0) queryClient.invalidateQueries(['beard', 'items', 'requests'])
        if (counts.flights_unviewed.length > 0) queryClient.invalidateQueries(['beard', 'items', 'flights'])
        if (counts.subscriptions_unviewed.length > 0) queryClient.invalidateQueries(['beard', 'items', 'subscriptions'])
    }, [ counts ])

    const { data: requests, isFetching: isRequestsLoading, isError: isRequestsError, isSuccess: isRequestsLoaded } = ReactQuery.useQuery({
        queryKey: ['beard', 'items', 'requests'],
        queryFn: () => accountAction.fetchMyRequests(),
        enabled: isOpened && tab === TABS.REQUESTS,
        staleTime: 1000 * 60 * 5,
    })

    const { data: flights, isFetching: isFlightsLoading, isError: isFlightsError, isSuccess: isFlightsLoaded } = ReactQuery.useQuery({
        queryKey: ['beard', 'items', 'flights'],
        queryFn: () => accountAction.fetchMyFlights(),
        enabled: isOpened && tab === TABS.FLIGHTS,
        staleTime: 1000 * 60 * 5,
    })

    const { data: subscriptions, isFetching: isSubscriptionsLoading, isError: isSubscriptionsError, isSuccess: isSubscriptionsLoaded } = ReactQuery.useQuery({
        queryKey: ['beard', 'items', 'subscriptions'],
        queryFn: () => accountAction.fetchMySubscriptions(),
        enabled: isOpened && tab === TABS.SUBSCRIPTIONS,
        staleTime: 1000 * 60 * 5,
    })

    React.useEffect(() => {
        const disposeShowBeard = listenEvent("showOrdersBeard", showOrdersBeard)
        const disposeHideBeard = listenEvent("hideOrdersBeard", hideOrdersBeard)

        $(document).on('click', function(e) {
            if (!$(e.target).closest('.push-wrapp, .logined-link').length) {
                raiseEvent('hideOrdersBeard');
            }
        })

        $(document).on('keyup', function(e) {
            if (e.key === "Escape") {
                raiseEvent('hideOrdersBeard');
            }
        })

        new SimpleBar($('#reactOrdersBeard').closest('.push-bag')[0]);

        return () => {
            disposeShowBeard()
            disposeHideBeard()
            disposeCountUpdated()
        }
    }, [])

    React.useEffect(() => {
        if (isOpened) {
            $('#reactOrdersBeard').closest('.push-bag').addClass('opened')
        } else {
            $('#reactOrdersBeard').closest('.push-bag').removeClass('opened')
        }
    }, [isOpened])

    function showOrdersBeard(props) {
        setIsOpened(true)
        if (props && props.type && props.type.toUpperCase() in TABS) {
            setTab(props.type)

            if (props.fetch) {
                queryClient.invalidateQueries({ queryKey: ['beard', 'items', props.type] })
            }
        }
    }

    function hideOrdersBeard() {
        setIsOpened(false)
    }

    const isLoading = isRequestsLoading || isFlightsLoading || isSubscriptionsLoading
    const isError = isRequestsError || isFlightsError || isSubscriptionsError

    return (
        <div className="push-scroll">
            <div className="push-wrapp">
                <div className="push-bag__top2">
                    <ul className="push-bag__tab2">
                        {feature_enabled('FEATURE_SUBSCRIPTIONS') && <BeardTab tab={tab} id={TABS.SUBSCRIPTIONS} title={__('menu.tab.subscriptions')} count={counts.subscriptions} countActive={counts.subscriptions_unviewed.length > 0} onSelect={setTab} />}
                        <BeardTab tab={tab} id={TABS.REQUESTS} title={__('menu.tab.requests')} count={counts.requests} countActive={counts.requests_unviewed.length > 0} onSelect={setTab} />
                        <BeardTab tab={tab} id={TABS.FLIGHTS} title={__('menu.tab.flights')} count={counts.flights} countActive={counts.flights_unviewed.length > 0} onSelect={setTab} />
                    </ul>
                </div>

                {isLoading && <Loading active={true} absolute={false} />}
                {isError && <span>Что-то пошло не так</span>}

                {tab === TABS.SUBSCRIPTIONS && isSubscriptionsLoaded && <BeardSubscriptionsList items={subscriptions.items} unviewed={counts.subscriptions_unviewed} itemsEmpty={subscriptions.itemsEmpty} />}
                {tab === TABS.REQUESTS && isRequestsLoaded && <BeardRequestsList items={requests.items} unviewed={counts.requests_unviewed} itemsEmpty={requests.itemsEmpty} />}
                {tab === TABS.FLIGHTS && isFlightsLoaded && <BeardFlightsList items={flights.items} unviewed={counts.flights_unviewed} itemsEmpty={flights.itemsEmpty} />}
            </div>
        </div>
    )
}

const domContainer = document.querySelector('#reactOrdersBeard')
const root = ReactDOM.createRoot(domContainer)
root.render(React.createElement(withQueryClient(OrdersBeardContainer)))
